import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSpaces } from '../context/SpaceContext';
import api from '../services/api';
import './DashboardPage.css';

export default function DashboardPage() {
  const { user } = useAuth();
  const { spaces, loading } = useSpaces();
  const [unreadCount, setUnreadCount] = useState(null);

  useEffect(() => {
    api.get('/inbox/unread-count')
      .then((res) => setUnreadCount(res.data.count))
      .catch(() => setUnreadCount(0));
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Welcome, {user?.name}</h1>
        <p className="dashboard-sub">Your workspace overview</p>
      </div>

      <div className="dashboard-grid">
        <section className="dash-card">
          <h2>Spaces ({spaces.length})</h2>
          {loading ? (
            <p className="muted">Loading...</p>
          ) : spaces.length === 0 ? (
            <p className="muted">No spaces yet. Create one from the sidebar.</p>
          ) : (
            <ul className="dash-space-list">
              {spaces.map((space) => (
                <li key={space._id}>
                  <Link to={`/spaces/${space._id}`} className="dash-space-link">
                    <span className="dash-space-badge">{space.name[0].toUpperCase()}</span>
                    <div>
                      <div className="dash-space-name">{space.name}</div>
                      <div className="dash-space-type">{space.type}</div>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </section>

        <section className="dash-card">
          <h2>Quick Access</h2>
          <div className="quick-links">
            <Link to="/inbox" className="quick-link">
              ✉ Inbox
              {unreadCount > 0 && <span className="dash-unread-badge">{unreadCount}</span>}
            </Link>
            <Link to="/calendar" className="quick-link">◷ Calendar</Link>
            <Link to="/files" className="quick-link">⊘ Files</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
